





























import LazyHydrate from 'vue-lazy-hydration';
import { useRoute, useRouter, defineComponent, onMounted, ref, useContext, computed } from '@nuxtjs/composition-api';
import { useUiState } from '~/composables';
import AppHeader from '~/components/AppHeader.vue';
import BottomNavigation from '~/components/BottomNavigation.vue';
import IconSprite from '~/components/General/IconSprite.vue';
import TopBar from '~/components/TopBar/TopBar.vue';
import TopMenu from '~/components/TopBar/TopMenu.vue';
import MainNavigation from '~/components/TopBar/MainNavigation.vue';
import MainNavigation2 from '~/components/TopBar/MainNavigation2.vue';
import { useCustomerStore } from '~/modules/customer/stores/customer';
import { useCart } from '~/modules/checkout/composables/useCart';
import HelpModal from '~/modules/czar/HelpModal/HelpModal.vue';
import tickerBlock from '~/components/czar/customTickerBar/tickerBlock.vue';
import { useExtendWarranty }  from '~/components/czar/checkout/cart/useExtendWarranty';
import { useUser } from '~/modules/customer/composables/useUser';
import { SfLoader } from '@storefront-ui/vue';

export default defineComponent({
  name: 'DefaultLayout',

  components: {
    LazyHydrate,
    AppHeader,
    BottomNavigation,
    IconSprite,
    TopBar,
    TopMenu,
    MainNavigation,
    MainNavigation2,
    AppFooter: () => import(/* webpackPrefetch: true */ '~/components/Footer/AppFooter.vue'),
    CartSidebar: () => import(/* webpackPrefetch: true */ '~/modules/checkout/components/CartSidebar.vue'),
    WishlistSidebar: () => import(/* webpackPrefetch: true */ '~/modules/wishlist/components/WishlistSidebar.vue'),
    LoginModal: () => import(/* webpackPrefetch: true */ '~/modules/customer/components/LoginModal/LoginModal.vue'),
    CheckoutLoginModal: () => import(/* webpackPrefetch: true */ '~/modules/checkout/components/CheckoutLoginModal.vue'),
    HelpModal,
    Notification: () => import(/* webpackPrefetch: true */ '~/components/Notification.vue'),
    tickerBlock,
    SfLoader
  },

  setup() {
    const route = useRoute();
    const router = useRouter();
    const { app } = useContext();
    const {
      isCartSidebarOpen, 
      isWishlistSidebarOpen, 
      isLoginModalOpen, 
      toggleLoginModal, 
      isCheckoutLoginModalOpen, 
      toggleCheckoutLoginModal, 
      isHelpModelOpen, 
      toggleHelpModal
    } = useUiState();
    const { loadTotalQty: loadCartTotalQty, load: loadCart } = useCart();
    const quote_id = computed(() => route.value.query.quote_id ?? '');
    const { addWarrantyToCart, warranty_adding } = useExtendWarranty();
    const { isAuthenticated } = useUser();

    onMounted(async () => {
      const apiState = app.context.$vsf.$magento.config.state;

      if (quote_id.value) {
        apiState.setCartId(quote_id.value);
        console.log('Cart ID was set:');
        try {
          await loadCart();
          await loadCartTotalQty();
        } catch (error) {
          console.error('Error updating cart:', error);
        }
        const newQuery = { ...route.value.query };
        delete newQuery.quote_id;
        router.replace({ query: newQuery });
      }

      if (process.client) {
        const leadToken = route.value.query.leadToken as string;
        if (leadToken) {
          // @ts-ignore
          Extend.aftermarketModal.open({
            leadToken: leadToken,
            storeId: 'cb9140a0-e99c-4755-ae3f-1a09b470b8ea',
            region: 'US',
            locale: 'en_US',
            onClose: function(plan, product, qty) {
              if (plan && product && qty) {
                var warranty = {
                  planId: plan.planId,
                  coverageType: plan.coverageType,
                  price: plan.price,
                  term: plan.term,
                  title: plan.title,
                  product: product.id,
                  offerPlanId: plan.offerPlanId
                };
                addWarrantyToCart(warranty, qty, isAuthenticated);
              }
            }
          })
        }
      }
    });

    return {
      isCartSidebarOpen,
      isWishlistSidebarOpen,
      isLoginModalOpen,
      toggleLoginModal,
      isCheckoutLoginModalOpen,
      toggleCheckoutLoginModal,
      isHelpModelOpen,
      toggleHelpModal,
      route,
      warranty_adding
    };
  },
  head: {
    link: [{ rel: 'stylesheet', href: '/_nuxt/fonts.css' }],
  },
});
